import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Content from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/Content';

const ContentWithContext = (props) => {
  const {
    setModalCollection,
  } = useModalContext();

  return <Content {...props} setCollection={setModalCollection} />;
};

export default ContentWithContext;
